import { IBranchTransferExecuteValues, IBranchTransferPreview, IBranchTransferPreviewPersistence, IBranchTransferSummary, IBranchTransferSummaryPersistence } from '../interfaces';

export class BranchTransferMapper {
  public static previewToDomain(data: IBranchTransferPreviewPersistence): IBranchTransferPreview {
    return {
      fromBranch: data.from_branch ? { id: data.from_branch.id, name: data.from_branch.branch_name } : null,
      toBranch: data.to_branch ? { id: data.to_branch.id, name: data.to_branch.branch_name } : null,
      declarations: {
        total: data.declarations.total,
        byState: data.declarations.by_state.map((state) => ({ stateId: state.state_id, stateName: state.state_name || `#${state.state_id}`, count: state.count })),
        localWarehouse: data.declarations.local_warehouse,
      },
      containerRequired: data.container_required,
      containers: data.containers.map((container) => ({ id: container.id, name: container.container_name })),
      customers: data.customers,
      admins: data.admins,
    };
  }

  public static executeToPersistence(values: IBranchTransferExecuteValues) {
    return {
      from_branch_id: values.fromBranchId,
      to_branch_id: values.toBranchId,
      state_ids: values.stateIds,
      container_id: values.containerId,
    };
  }

  public static summaryToDomain(data: IBranchTransferSummaryPersistence): IBranchTransferSummary {
    return {
      declarations: data.declarations,
      localWarehouse: data.local_warehouse,
      customers: data.customers,
      admins: data.admins,
    };
  }
}
